<template>
  <div class="topHeader sticky top-0 left-0 right-0 z-10">
    <div class="flex-center-y">
      <span @click="showSideBar(false)" class="switcher"></span>
      <span class="logo"></span>
    </div>
    <div v-if="isLoggedIn" class="flex-center-y gap-2 self-center">
      <img src="@a/assets/images/i_meiyuan.png" class="size-4" />
      <strong class="font-bold text-[13px]">{{ formatter().format(wallet.balance) }}</strong>
      <img
        src="@a/assets/images/sanjiao_bai.png"
        class="size-4"
        :class="{ 'rotate-180': !showUserInfo }"
        @click="showUserInfo = !showUserInfo"
      />
      <div v-if="showUserInfo">
        <div class="top-user-panel">
          <div class="top-user-panel-arrow"></div>
          <div class="top-user-panel-body">
            <div class="top-user-info" @click="$router.push('/profile')">
              <img :src="`/static/images/avatar${user.avatarUrl || '/02.png'}`" class="size-[32px] rounded-full" />
              <div class="top-user-name"> {{ user.nickname }} </div>
            </div>
            <div class="flex-center-y">
              <div class="top-user-uid">{{ $t('home.TopHeader.Id') }} {{ user.userid }} </div>
              <img @click="copyText(user.userid)" src="@a/views/Home/images/i1.png" class="size-[24px]" />
            </div>
            <div class="flex-center-y justify-between rounded-[5px] mt-2 h-10 bg-[#2C795226]">
              <div class="flex-center-y">
                <img src="@a/assets/images/i_meiyuan.png" class="top-user-panel-coinimg w-5 ml-3" />
                <span class="ml-[4px]">{{ $t('home.TopHeader.SA') }}</span>
              </div>
              <span class="text-[13px] mr-3 bold">
                {{ formatter().format(wallet.balance) }}
              </span>
            </div>
            <div class="flex-center-y justify-start h-[40px] mt-[4px]">
              <img src="@a/views/Home/images/level_1_1.png" class="w-[33px]"/>
              <div class="top-user-panel-level-line"></div>
              <img
                src="@a/views/Home/images/i5.png"
                class="top-user-panel-vipicon w-[42px] h-[20px] ml-2"
              />
              <div class="top-user-panel-viptext">0</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="fns" v-else>
      <div @click="$router.push('/login')" class="login">{{ $t('LoginOrReg.Login') }}</div>
      <div @click="$router.push('/reg')" class="register">{{ $t('LoginOrReg.Reg') }}</div>
    </div>
  </div>
</template>
<script setup lang="ts">
  import { useUserInfo, useWallet } from '@/store'
  import { copyText, formatter } from '@/utils'
  import SideBar from './sideBar.vue'
  import showPopup from '@a/components/showPopup'

  const isLoggedIn = computed(() => useUserInfo().isLoggedin)
  const user = computed(() => useUserInfo().userInfo!)
  const showUserInfo = ref(false)

  useWallet().init()
  const wallet = computed(() => useWallet().wallet)

  // onActivated(() => {
  //   useWallet().init()
  // })

  // onActivated(() => {
  //   if (sessionStorage.getItem('deactivated') === '1') {
  //     if (sessionStorage.getItem('showSideBar') === '1') showSideBar(true)
  //     delete sessionStorage.deactivated
  //   }
  // })

  // onDeactivated(() => {
  //   sessionStorage.setItem('showSideBar', openSidebar.value ? '1' : '0')
  //   sessionStorage.setItem('deactivated', '1')
  // })

  const openSidebar = ref(false)
  const showSideBar = (showSideBarAtOnce?: boolean) => {
    showPopup(SideBar, {
      position: 'left',
      style: { width: '73%', height: '100%' },
      duration:  showSideBarAtOnce ? 0 : 0.3,
      class: '!bg-[#0C2115]/60 backdrop-blur-sm',
      closeOnClickOverlay: true,
      // @ts-ignore
      onOpened: () => {
        openSidebar.value = true
      },
      onClosed: () => {
        openSidebar.value = false
      }
    })
  }
</script>

<style lang="scss">
  .topHeader {
    @apply flex justify-between items-end py-[14px] px-[16px] bgs-[url('@/themes/theme_a/assets/images/bg.png')] bg-fixed bg-[var(--theme-primary-dark)];

    .switcher {
      @apply size-6 mr-1.5 bg-[var(--theme-primary)];

      -webkit-mask: url('@a/views/Home/images/arrow_right.png') no-repeat center bottom / 100% auto;
      mask: url('@a/views/Home/images/arrow_right.png') no-repeat center bottom / 100% auto;
    }

    .logo {
      @apply w-[118px] h-[26px] bgs-[url('@/assets/logo.png')];
    }

    .fns {
      @apply flex text-center leading-[25px] text-[13px];

      .login {
        @apply w-[58px] h-[25px] bg-[#25CE75] text-[var(--theme-primary-dark)] rounded-[15px] mr-[12px];
      }

      .register {
        @apply w-[64px] h-[25px] text-[#25CE75] rounded-[15px] bd-[1px_#25CE75] bg-[transparent];
      }
    }

    .top-user-panel {
      @apply absolute-rt-[15px_40px] w-[260px] h-[206px] bg-transparent z-[99];

      .top-user-panel-arrow {
        @apply wh-[20px_8px] absolute-rt-[6px_4px] z-[100] bgs-[url('@a/assets/images/i_panel_arrow.png')] bd-b-[2px_var(--theme-text-dark)];
      }
      .top-user-panel-body {
        @apply absolute-rt-[-13px_9px] w-full p-[15px_15px_10px] bg-[var(--theme-text-dark)] rounded-[5px] shadow-[0_2px_4px_0_rgba(0,0,0,0.08)] bd-[1px_var(--theme-border-color)];

        .top-user-info {
          @apply flex-center-y;

          .top-user-name {
            @apply w-[155px] h-[30px] leading-[30px] rounded-[15px] ml-[10px];
          }
        }
        .top-user-uid {
          @apply opacity-75 leading-[28px] mt-[5px] mr-[5px];
        }
        .top-user-panel-level-line {
          @apply w-[1px] h-[10px] opacity-50 bg-white ml-[6px] mr-[2px];
        }
        .top-user-panel-viptext {
          @apply size-5 leading-20 text-14 rounded-2 text-center text-white ml-[5px] bg-gradient-to-tr from-[#fcd7a1] to-[#d17836];
        }
      }
    }
  }
</style>
